import type { AdminUser, AdminWhatsappAccount } from "./types.ts";

export function WhatsappAccessMatrix({
  users,
  accounts,
  loading,
  accessSaving,
  userHasAccess,
  onToggleAccess,
}: {
  users: AdminUser[];
  accounts: AdminWhatsappAccount[];
  loading: boolean;
  accessSaving: string | null;
  userHasAccess: (targetUserId: number, account: AdminWhatsappAccount) => boolean;
  onToggleAccess: (targetUser: AdminUser, account: AdminWhatsappAccount, currentlyHas: boolean) => void;
}) {
  const sellerUsers = users.filter((user) => user.role !== "admin");

  return (
    <section className="admin-section admin-section-wide">
      <div className="admin-section-head">
        <h2>Acesso WhatsApp</h2>
        <span>{accounts.length} {accounts.length === 1 ? "conta" : "contas"} — marque pra liberar</span>
      </div>
      <p className="admin-section-hint">
        Cada usuário só vê na SPA as contas onde tiver checkbox marcado. Donas (fixo) não podem ser desmarcadas — só transferindo a sessão. Mudanças entram em vigor imediatamente via WebSocket.
      </p>
      <div className="admin-table-wrap">
        <table className="admin-table admin-access-matrix">
          <thead>
            <tr>
              <th>Vendedor</th>
              {accounts.map((account) => (
                <th key={account.sessionId} title={`${account.provider} - ${account.accountType} - dono: ${account.ownerEmail}`}>
                  <div className="admin-access-col-head">
                    <span className="admin-access-acc-label">{account.label || account.sessionId.slice(0, 8)}</span>
                    <span className="admin-access-acc-meta">{account.accountType || "wa"} - {account.pushName || account.sessionId.slice(0, 6)}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sellerUsers.map((user) => (
              <tr key={user.id}>
                <td>
                  <strong>{user.email}</strong>
                  <span>id={user.id} - {user.role}</span>
                </td>
                {accounts.map((account) => {
                  const isOwner = account.ownerUserId === user.id;
                  const has = userHasAccess(user.id, account);
                  const saving = accessSaving === `${user.id}:${account.sessionId}`;
                  return (
                    <td key={account.sessionId} className="admin-access-cell">
                      <label className={`admin-access-toggle ${isOwner ? "is-owner" : ""}`} title={isOwner ? "Dono da sessão" : (has ? "Clique para remover" : "Clique para liberar")}>
                        <input
                          type="checkbox"
                          checked={has}
                          disabled={isOwner || saving}
                          onChange={() => onToggleAccess(user, account, has)}
                        />
                        {isOwner ? <span className="admin-access-owner-tag">dono</span> : null}
                      </label>
                    </td>
                  );
                })}
              </tr>
            ))}
            {!sellerUsers.length ? (
              <tr><td colSpan={accounts.length + 1}>{loading ? "Carregando..." : "Nenhum vendedor cadastrado."}</td></tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
}
